/** Premium account API calls - portfolio holdings + price alerts (per user). */
import { apiFetch } from './apiClient';

// Portfolio
export const getPortfolio = () => apiFetch('/api/account/portfolio');
export const addHolding = (body) => apiFetch('/api/account/portfolio', { method: 'POST', body });
export const removeHolding = (id) => apiFetch(`/api/account/portfolio/${id}`, { method: 'DELETE' });

// Alerts
export const getAlerts = () => apiFetch('/api/account/alerts');
export const createAlert = (body) => apiFetch('/api/account/alerts', { method: 'POST', body });
export const updateAlert = (id, body) => apiFetch(`/api/account/alerts/${id}`, { method: 'PUT', body });
export const deleteAlert = (id) => apiFetch(`/api/account/alerts/${id}`, { method: 'DELETE' });
export const checkAlerts = () => apiFetch('/api/account/alerts/check');

// Notification settings. These live server-side because the alert sender has
// to be able to read the opt-out; a browser-only toggle could not stop mail.
export const getNotificationSettings = () => apiFetch('/api/account/settings');
export const updateNotificationSettings = (body) =>
  apiFetch('/api/account/settings', { method: 'PUT', body });
